import React, { useContext, useEffect, useState } from "react";
import { Button } from "../../../../../../stories/Button/Button";
import useFormJson from "../../../../../../json/useFormJson";
import { LabelProps } from "../../../../../../utils/types";
import TextArea from "../../../../../../stories/TextArea/TextArea";
import { Junction } from "./queries/types";
import { nodeVar } from "../../../../../../utils/commonQueryTypes";
import { useLazyQuery } from "@apollo/client";
import { GetJunctionNode } from "./queries/queries";
import { AppContext } from "../../../../../../context/context";
import { Label } from "../../../../../../stories/Label/Label";
import { EMPTY_STRING, emptyMessage } from "../../../../../../utils/constants";
import Input from "../../../../../../stories/Input/Input";
import { Title } from "../../../../../../stories/Title/Title";
import Close from "../../../../../../images/Close.svg";
import { getDownloadUrl } from "../../../../../../utils/DownloadFile";
import DocumentsDownload from "../../../../../../images/DocumentsDownload.svg";
import Gallery from "../../../../../../images/DownloadImage.svg";
import { Operation } from "../../../../../../utils/Enum.types";
import image from "../../../../../../images/Formatter Icons/image.svg";
import { ViewTicketModalStyles } from "../../../../../../styles/CustomModalStyles";
import {
  CustomModal,
  getMediaType,
} from "../../../../../../utils/UtilFunctions";
import MessageModal from "../../../../../../customComponents/MessageModal";
import useLabels from "../../../../../../customHooks/useLabels";
import MediaList from "./MediaList";

interface Props {
  setModalFlag: React.Dispatch<React.SetStateAction<boolean>>;
}
const ParticuarJunctionDetails = ({ setModalFlag }: Props) => {
  const { JunctionsFormLabels } = useFormJson();
  const { state } = useContext(AppContext);
  const [mutationCompleted, setMutationCompleted] = useState(false);
  const [imageData, setImageData] = useState<{
    filename: string;
    url: string;
  }>({ filename: "", url: "" });
  const [imageModal, setImageModal] = useState(false);
  const [message, setMessage] = useState(emptyMessage);
  const [selectedImage, setSelectedImage] = useState<string | null>(null);
  const [selectedVideo, setSelectedVideo] = useState<string | null>(null);

  const [allImages, setAllImages] = useState<
    {
      filename: string;
      url: string;
    }[]
  >([]);
  const { companyLabel, subsidiaryLabel, subsidiarySiteLabel } = useLabels();

  const [GetJunctionByNode, { data: junctionData }] = useLazyQuery<
    { node: Junction },
    nodeVar
  >(GetJunctionNode);

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (state.junctionID) {
          GetJunctionByNode({
            variables: {
              id: state.junctionID,
            },
          });
        }
      } catch (err) {
        console.error((err as Error).message);
      }
    };
    fetchData();
  }, [state.companyId, GetJunctionByNode]);

  const handleClear = () => {
    setMessage(emptyMessage);
  };

  useEffect(() => {
    if (junctionData && junctionData.node.images) {
      const getImages = async () => {
        const images = junctionData.node.images.split(";");
        for (let i = 0; i < images.length; i++) {
          try {
            const ext = images[i].split(".").pop();
            const filename = `${junctionData.node.companyID}/junctionDetails/${junctionData.node.id}_${i}.${ext}`;
            const ers = await getDownloadUrl(filename, false);
            setAllImages((prev) => [
              ...prev,
              {
                filename,
                url: ers as string,
              },
            ]);
          } catch (error) {
            setMessage({
              flag: true,
              message: "Failed to fetch image",
              operation: Operation.NONE,
            });
          }
        }
      };

      getImages();
    }
  }, [junctionData]);

  useEffect(() => {
    if (allImages?.length) {
      setSelectedImage(allImages[0].url);
    }
  }, [allImages]);
  return (
    <>
      <div className="view-junctions">
        <div className="view-junctions__title">
          <Title>{junctionData ? junctionData.node.name : EMPTY_STRING}</Title>
          <img src={Close} alt="" onClick={() => setModalFlag(false)} />
        </div>
        <div className="view-junctions__flex">
          <div className="view-junctions__flex--left">
            <div className="label-grid">
              <Label>{companyLabel}</Label>
              <Input
                value={junctionData?.node.company.name ?? EMPTY_STRING}
                disabled
              />
            </div>
            <div className="label-grid">
              <Label>{subsidiaryLabel}</Label>
              <Input
                value={junctionData?.node.subsidiary.name ?? EMPTY_STRING}
                disabled
              />
            </div>
            <div className="label-grid">
              <Label>{subsidiarySiteLabel}</Label>
              <Input
                value={junctionData?.node.subsidiary.name ?? EMPTY_STRING}
                disabled
              />
            </div>
            {JunctionsFormLabels.map((field: LabelProps, key: React.Key) => {
              if (field.dataType === "textarea") {
                return (
                  <React.Fragment key={key}>
                    <div className="label-grid">
                      <Label>{field.labelName}</Label>
                      <TextArea
                        value={
                          junctionData
                            ? junctionData.node.address
                            : EMPTY_STRING
                        }
                        rows={3}
                        disabled
                      />
                    </div>
                  </React.Fragment>
                );
              }
              // else if (field.dataType === "icon") {
              //   return (
              //     <IconSelect
              //       onChange={(newValue) => {
              //         if (newValue) {
              //           setFormData({
              //             ...formData,
              //             icon: newValue.value as unknown as string,
              //           });
              //         } else {
              //           setFormData({
              //             ...formData,
              //             icon: "",
              //           });
              //         }
              //       }}
              //     />
              //   );
              // }
                   else if (field.inputName === "ldgrID") {
                return (
                  <React.Fragment key={key}>
                    <div className="label-grid">
                      <Label>{field.labelName}</Label>

                      <Input
                        value={
                          junctionData?.node?.vendorDetails?.desc ?? EMPTY_STRING
                        }
                        disabled
                      />
                    </div>
                  </React.Fragment>
                );
              }
              else {
                return (
                  <React.Fragment key={key}>
                    <div className="label-grid">
                      <Label>{field.labelName}</Label>

                      <Input
                        value={
                          junctionData?.node[
                            field.inputName as keyof Junction
                          ] ?? EMPTY_STRING
                        }
                        disabled
                      />
                    </div>
                  </React.Fragment>
                );
              }
            })}
            <div className="label-grid">
              <Label>Images</Label>
              <div className="d-flex">
                {/* {allImages.length
                  ? allImages.map((item, index) => (
                      <div className="view-images" key={index}>
                        <img
                          src={item.url ? item.url : Gallery}
                          alt="/"
                          onClick={async () => {
                            setImageData({
                              filename: item.filename,
                              url: item.url,
                            });
                            setImageModal(true);
                          }}
                        />
                      </div>
                    ))
                  : null} */}
                {/* {junctionData && junctionData.node && junctionData.node.images
                ? junctionData.node.images.split(";").map((res, index) => (
                    <div
                      key={index}
                      onClick={async () => {
                        try {
                          setMutationCompleted(true);
                          const ext = res.split(".").pop();
                          const filename = `${junctionData.node.companyID}/junctionDetails/${junctionData.node.id}_${index}.${ext}`;
                          const ers = await getDownloadUrl(filename, false);
                          setImageData({
                            filename: filename,
                            url: ers,
                          });
                          setImageModal(true);
                          setMutationCompleted(false);
                        } catch (error) {
                          setMutationCompleted(false);
                          setMessage({
                            flag: true,
                            message: "Failed to fetch image",
                            operation: Operation.NONE,
                          });
                        }
                      }}
                    >
                      <img src={image} alt="" />
                    </div>
                  ))
                : null} */}
              </div>
            </div>
          </div>
          <div className="view-junctions__flex--flex-item">
            {selectedImage && (
              <div className="view-junctions__flex--preview">
                <img src={selectedImage} alt="preview" />
              </div>
            )}
            {selectedVideo && (
              <div className="view-junctions__flex--preview">
                <video controls preload="metadata" height="100%" width="100%">
                  <source src={selectedVideo} type="video/mp4" />
                  <source src={selectedVideo} type="video/webm" />{" "}
                  {/* if not support */}
                  Your browser does not support the video tag.
                </video>
              </div>
            )}

            <div className="view-junctions__flex--thumbnails">
              {/* {allImages?.map((img, index) => (
                <div
                  key={index}
                  className={`view-junctions__flex--thumb ${img.url === selectedImage ? "active" : ""}`}
                  onClick={() => setSelectedImage(img.url)}
                >
                  <img src={img.url} alt={img.filename} />
                </div>
              ))} */}
              {allImages?.map((img, index) => {
                const type = getMediaType(img);
                const fileName = img.filename.split("/").pop() || "media";

                return (
                  <div
                    key={index}
                    className={`view-junctions__flex--thumb ${img.url === selectedImage ? "active" : ""}`}
                  >
                    {type === "image" ? (
                      <img
                        src={img.url}
                        alt={fileName}
                        loading="lazy"
                        onClick={() => {
                          setSelectedVideo(null);
                          setSelectedImage(img.url);
                        }}
                      />
                    ) : (
                      <video
                        controls
                        preload="metadata"
                        height="100%"
                        width="100%"
                        onClick={() => {
                          setSelectedImage(null);
                          setSelectedVideo(img.url);
                        }}
                      >
                        <source src={img.url} type="video/mp4" />
                        <source src={img.url} type="video/webm" />{" "}
                        {/* if not support */}
                        Your browser does not support the video tag.
                      </video>
                    )}
                  </div>
                );
              })}
            </div>
            {/* {allImages.length && <MediaList files={allImages} />} */}
          </div>
        </div>

        <Button mode="cancel" onClick={() => setModalFlag(false)} />

        <CustomModal
          isOpen={imageModal}
          onRequestClose={() => setImageModal(!imageModal)}
          contentComponent={
            <div className="import-excel-data__modal">
              <div className="import-excel-data--title">
                <img
                  className="me-5"
                  src={DocumentsDownload}
                  alt=""
                  onClick={async () => {
                    try {
                      setMutationCompleted(true);
                      const ers = await getDownloadUrl(
                        imageData.filename,
                        true,
                      );

                      setMutationCompleted(false);
                    } catch (error) {
                      setMutationCompleted(false);
                      setMessage({
                        flag: true,
                        message: "Failed to fetch image",
                        operation: Operation.NONE,
                      });
                    }
                  }}
                />
                <img
                  src={Close}
                  alt=""
                  onClick={() => {
                    setImageModal(false);
                  }}
                />
              </div>

              <div className="view-image">
                <img src={imageData.url ? imageData.url : Gallery} alt="/" />
              </div>
            </div>
          }
          style={ViewTicketModalStyles}
        />
      </div>
      <MessageModal
        modalFlag={message.flag!}
        value={message.message!}
        handleClose={handleClear}
        operation={message.operation!}
      />
    </>
  );
};

export default ParticuarJunctionDetails;
